import { render, staticRenderFns } from "./MooTest.vue?vue&type=template&id=73766a38"
import script from "./MooTest.vue?vue&type=script&lang=js"
export * from "./MooTest.vue?vue&type=script&lang=js"
import style0 from "./MooTest.vue?vue&type=style&index=0&id=73766a38&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports